// @ts-strict-ignore
import { Directive, EventEmitter, Output } from '@angular/core';
import { LMCtrlShiftClickBaseComponent, LMNavigationService } from '@app/components';
import { LMComponentInfoService, LMUrlUtilService } from '@app/services';
import { KeyedResource } from '@app/resources';

@Directive()
export abstract class LMCardBaseDirective extends LMCtrlShiftClickBaseComponent {
  @Output() toolbarButtonEvent = new EventEmitter<LMToolbarButtonEvent>();

  constructor(
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmNavigationService: LMNavigationService,
    protected lmUrlUtilService: LMUrlUtilService
  ) {
    super(lmComponentInfoService);
  }

  public onActionClicked(event): void {
    // For keydown events, only proceed on Enter key
    if (event instanceof KeyboardEvent) {
      if (event.key !== 'Enter') {
        return;
      }
    }

    if (event.target && (event.target.nodeName === 'BUTTON' || event.target.nodeName === 'A')) {
      const actionSpec = event?.target?.dataset?.actionSpec;
      const actionReference: LMBusActionReference = JSON.parse(event?.target?.dataset?.actionReference);

      if (actionReference?.type === 'subform' && actionReference.cardViewFormButtonSpec.subFormAction) {
        this.onToolbarButtonEvent({
          actionSpec: actionSpec ? JSON.parse(actionSpec) : null,
          actionReference,
          event
        });
      } else {
        this.onToolbarButtonEvent({
          actionSpec: actionSpec ? JSON.parse(actionSpec) : null,
          actionReference,
          event
        });
      }
    }
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent) {
    this.toolbarButtonEvent.emit(toolbarButtonEvent);
  }

  public external(item: LMCardViewButton, event: Event) {
    // For keydown events, only proceed on Enter key
    if (event instanceof KeyboardEvent) {
      if (event.key !== 'Enter') {
        return;
      }
    }

    event.preventDefault();

    // When getting a http url/linkback that returns a navigation, we need to handle
    // by calling runNavigation instead of navigate. This will prevent the navigation
    // url from replacing the current lmclient route.
    // see LMCLIENT-35609.
    let resource: KeyedResource;
    try {
      //getRouteResource will throw an error if the url cannot be parsed.
      resource = this.lmUrlUtilService.getRouteResource(item.httpUrl);
    } catch (e) {
      //noop
    }

    if (resource?.resourceType === 'navigation') {
      this.lmNavigationService.runNavigation(item.httpUrl, undefined, { openNewTab: item.isOpenExternal });
    } else {
      this.lmUrlUtilService.openExternalUrl(item.httpUrl);
    }
  }

  public stringifyJson(actionReference: LMBusActionReference): string {
    const actionReferenceClone = JSON.parse(JSON.stringify(actionReference));
    if (actionReferenceClone.label && actionReferenceClone.label.search(/'/g) > -1) {
      // html encode single quotes as they screw up when placed into a element.dataset.
      actionReferenceClone.label = actionReferenceClone.label.replace(/'/g, (substring, ...args) => '&#39;');
    }

    return JSON.stringify(actionReferenceClone);
  }
}
